<template>
    <Modal :mask-closable="true" v-model="show" :title="title" :width="600" @on-cancel="clearFrom">
        <div class="QHcitySelect">
            <table class="QHtable">
                <tr v-if="provinceCode != -1 && !isDisabled.includes('provinceCode')">
                    <td width="80"><b>省份</b></td>
                    <td>
                        <Select placeholder="请选择省份" :label-in-value="true" v-model="provinceCode"
                            :multiple="cityCode == -1" @on-change="(event) => select(event, 1)"
                            :disabled="$isblank(this.provinceList)||isReadonly.includes('provinceCode')">
                            <Option :value="item.code" :label="item.name" v-for="(item, index) in provinceList"
                                :key="index">{{
                                    item.name }}</Option>
                        </Select>
                    </td>
                </tr>
                <tr v-if="cityCode != -1 && !isDisabled.includes('cityCode')">
                    <td width="80"><b>城市</b></td>
                    <td>
                        <Select placeholder="请选择城市" :label-in-value="true" v-model="cityCode"
                            :multiple="districtCode == -1" @on-change="(event) => select(event, 2)"
                            :disabled="$isblank(this.cityList)||isReadonly.includes('cityCode')">
                            <Option :value="item.code" :label="item.name" v-for="(item, index) in cityList"
                                :key="index">{{
                                    item.name }}</Option>
                        </Select>
                    </td>
                </tr>
                <tr v-if="districtCode != -1 && !isDisabled.includes('districtCode')">
                    <td width="80"><b>区县</b></td>
                    <td>
                        <Select placeholder="请选择区县" :label-in-value="true" v-model="districtCode"
                            :multiple="streetCode == -1" @on-change="(event) => select(event, 3, 1)"
                            :disabled="$isblank(this.districtList)||isReadonly.includes('districtCode')">
                            <Option :value="item.code" :label="item.name" v-for="(item, index) in districtList"
                                :key="index">{{
                                    item.name }}</Option>
                        </Select>
                    </td>
                </tr>
                <tr v-if="streetCode != -1 && !isDisabled.includes('streetCode')">
                    <td width="80"><b>街道</b></td>
                    <td>
                        <Select placeholder="请选择街道" :label-in-value="true" v-model="streetCode"
                            :multiple="shequCode == -1" @on-change="(event) => select(event, 4)"
                            :disabled="$isblank(this.streetList)||isReadonly.includes('streetCode')">
                            <Option :value="item.code" :label="item.name" v-for="(item, index) in streetList"
                                :key="index">{{
                                    item.name }}</Option>
                        </Select>
                    </td>
                </tr>
                <tr v-if="shequCode != -1 && !isDisabled.includes('shequCode')">
                    <td width="80"><b>社区</b></td>
                    <td>
                        <Select placeholder="请选择社区" :label-in-value="true" v-model="shequCode" :multiple="true"
                            @on-change="(event) => select(event, 5)" :disabled="$isblank(this.shequList)||isReadonly.includes('shequCode')">
                            <Option :value="item.code" :label="item.name" v-for="(item, index) in shequList"
                                :key="index">{{
                                    item.name }}</Option>
                        </Select>
                    </td>
                </tr>
            </table>
        </div>
        <div slot="footer">
            <Button @click="clearFrom">取消</Button>
            <Button type="primary" @click="ok">确定</Button>
        </div>
    </Modal>
</template>

<script>
export default {
    data() {
        return {
            //基础配置
            title: "选择地址",
            show: false,
            isDisabled: [],
            isReadonly: [],
            //省市县镇村
            provinceList: [],
            cityList: [],
            districtList: [],
            streetList: [],
            shequList: [],
            //返参
            provinceCode: -1,
            cityCode: -1,
            districtCode: -1,
            streetCode: -1,
            shequCode: -1
        }
    },

    // +----------------------------------------------------------------------
    // | Desc:methods
    // +----------------------------------------------------------------------
    methods: {
        //hiPop
        hiPop(addressAll, isDisabled, isReadonly) {
            this.clearFrom();
            this.isDisabled = isDisabled || [];
            this.isReadonly = isReadonly || [];
            if (addressAll.hasOwnProperty('provinceCode')) {
                var codeFmt = this.codeFmt(addressAll.provinceCode);
                this.provinceCode = codeFmt;
                this.getOpenCityList(1);
            };
            if (addressAll.hasOwnProperty('cityCode')) {
                var codeFmt = this.codeFmt(addressAll.cityCode);
                this.cityCode = codeFmt;
                var isArray = this.provinceCode instanceof Array;
                if (!isArray) {
                    this.getOpenCityList(2, this.provinceCode);
                };
            };
            if (addressAll.hasOwnProperty('districtCode')) {
                var codeFmt = this.codeFmt(addressAll.districtCode);
                this.districtCode = codeFmt;
                var isArray = this.cityCode instanceof Array;
                if (!isArray) {
                    this.getOpenCityList(3, this.cityCode);
                };
            };
            if (addressAll.hasOwnProperty('streetCode')) {
                var codeFmt = this.codeFmt(addressAll.streetCode);
                this.streetCode = codeFmt;
                var isArray = this.districtCode instanceof Array;
                if (!isArray) {
                    this.getOpenCityList(4, this.districtCode);
                };
            };
            if (addressAll.hasOwnProperty('shequCode')) {
                var codeFmt = this.codeFmt(addressAll.shequCode);
                this.shequCode = codeFmt;
                var isArray = this.streetCode instanceof Array;
                if (!isArray) {
                    this.getOpenCityList(5, this.streetCode);
                };
            };
            this.show = true;
        },

        //城市信息列表
        async getOpenCityList(level, code) {
            let that = this;
            if (level != 1 && this.$isblank(code)) {
                return;
            };
            if (level == 1 && this.provinceCode == -1) {
                return;
            };
            if (level == 2 && this.cityCode == -1) {
                return;
            };
            if (level == 3 && this.districtCode == -1) {
                return;
            };
            if (level == 4 && this.streetCode == -1) {
                return;
            };
            if (level == 5 && this.shequCode == -1) {
                return;
            };
            this.$loading(true);
            var parameter = {
                level: level,
                code: code || ""
            };
            try {
                const res = await this.$api.getOpenCityList(parameter);
                if (res.code == 0) {
                    if (level == 1) {
                        that.provinceList = res.data;
                    } else if (level == 2) {
                        that.cityList = res.data;
                    } else if (level == 3) {
                        that.districtList = res.data;
                    } else if (level == 4) {
                        that.streetList = res.data;
                    } else if (level == 5) {
                        that.shequList = res.data;
                    };
                } else {
                    that.$msg(res.msg, "error");
                };
            } catch (error) {
                console.error('Error:', error);
            } finally {
                this.$loading(false);
            }
        },

        //取值
        ok() {
            var addressAll = {
                provinceCode: this.provinceCode,
                cityCode: this.cityCode,
                districtCode: this.districtCode,
                streetCode: this.streetCode,
                shequCode: this.shequCode
            };
            //组合value
            var filteredAddressAll = Object.keys(addressAll).reduce((acc, key) => {
                if (addressAll[key] !== -1) {
                    acc[key] = addressAll[key];
                };
                return acc;
            }, {});
            var addressAll = filteredAddressAll;

            //组合label
            var addressFull = "";
            var selectCode = [];
            var selectValue = [];
            if (addressAll.hasOwnProperty('provinceCode')) {
                var list = this.provinceList;
                var codeFmt = addressAll.provinceCode;
                if (this.$isblank(codeFmt)) {
                    this.$msg("请完善选择", "error");
                    return;
                }
                var isArray = codeFmt instanceof Array;
                if (!isArray) {
                    var item = list.find(item => item.code == codeFmt);
                    addressAll.province = item.name;
                    addressFull = addressAll.province;
                };
                if (isArray) {
                    var selectCode = codeFmt.join(',');
                    var selectValue = list
                        .filter(item => codeFmt.includes(item.code))
                        .map(item => item.name);
                    var selectValue = selectValue.join(',');
                    addressAll.provinceCode = selectCode;
                };
            };

            if (addressAll.hasOwnProperty('cityCode')) {
                var list = this.cityList;
                var codeFmt = addressAll.cityCode;
                if (this.$isblank(codeFmt)) {
                    this.$msg("请完善选择", "error");
                    return;
                }
                var isArray = codeFmt instanceof Array;
                if (!isArray) {
                    var item = list.find(item => item.code == codeFmt);
                    addressAll.city = item.name;
                    if (addressAll.city != addressFull) {
                        addressFull = addressFull + addressAll.city;
                    };
                };
                if (isArray) {
                    var selectCode = codeFmt.join(',');
                    var selectValue = list
                        .filter(item => codeFmt.includes(item.code))
                        .map(item => item.name);
                    var selectValue = selectValue.join(',');
                    addressAll.cityCode = selectCode;
                };
            };

            if (addressAll.hasOwnProperty('districtCode')) {
                var list = this.districtList;
                var codeFmt = addressAll.districtCode;
                if (this.$isblank(codeFmt)) {
                    this.$msg("请完善选择", "error");
                    return;
                }
                var isArray = codeFmt instanceof Array;
                if (!isArray) {
                    var item = list.find(item => item.code == codeFmt);
                    addressAll.district = item.name;
                    addressFull = addressFull + addressAll.district;
                };
                if (isArray) {
                    var selectCode = codeFmt.join(',');
                    var selectValue = list
                        .filter(item => codeFmt.includes(item.code))
                        .map(item => item.name);
                    var selectValue = selectValue.join(',');
                    addressAll.districtCode = selectCode;
                };
            };

            if (addressAll.hasOwnProperty('streetCode')) {
                var list = this.streetList;
                var codeFmt = addressAll.streetCode;
                if (this.$isblank(codeFmt)) {
                    this.$msg("请完善选择", "error");
                    return;
                }
                var isArray = codeFmt instanceof Array;
                if (!isArray) {
                    var item = list.find(item => item.code == codeFmt);
                    addressAll.street = item.name;
                    addressFull = addressFull + addressAll.street;
                };
                if (isArray) {
                    var selectCode = codeFmt.join(',');
                    var selectValue = list
                        .filter(item => codeFmt.includes(item.code))
                        .map(item => item.name);
                    var selectValue = selectValue.join(',');
                    addressAll.streetCode = selectCode;
                };
            };

            if (addressAll.hasOwnProperty('shequCode')) {
                var list = this.shequList;
                var codeFmt = addressAll.shequCode;
                if (this.$isblank(codeFmt)) {
                    this.$msg("请完善选择", "error");
                    return;
                }
                var isArray = codeFmt instanceof Array;
                if (!isArray) {
                    var item = list.shequCode(item => item.code == codeFmt);
                    addressAll.shequ = item.name;
                    addressFull = addressFull + addressAll.shequ;
                };
                if (isArray) {
                    var selectCode = codeFmt.join(',');
                    var selectValue = list
                        .filter(item => codeFmt.includes(item.code))
                        .map(item => item.name);
                    var selectValue = selectValue.join(',');
                    addressAll.shequCode = selectCode;
                };
            };

            addressAll.selectCode = selectCode;
            addressAll.selectValue = selectValue;
            addressAll.addressFull = addressFull;
            this.$nextTick(() => {
                this.$emit('ok', addressAll);
                this.clearFrom();
            });
        },

        //选择地址
        select(event, level) {
            var event = JSON.parse(JSON.stringify(event));
            var isArray = event instanceof Array;
            if (this.$isblank(event)) {
                var code = "";
            } else {
                if (isArray) {
                    var code = event;
                } else {
                    var code = event.value;
                };
            };


            //选择省份
            if (level == 1) {
                this.cityList = [];
                this.districtList = [];
                this.streetList = [];
                this.shequList = [];
                this.cityCode = this.disabled(this.cityCode, -1);
                this.districtCode = this.disabled(this.districtCode, -1);
                this.streetCode = this.disabled(this.streetCode, -1);
                this.shequCode = this.disabled(this.shequCode, -1);
                if (!isArray) {
                    this.getOpenCityList(2, code);
                };
            };

            //选择城市
            if (level == 2) {
                this.districtList = [];
                this.streetList = [];
                this.shequList = [];
                this.districtCode = this.disabled(this.districtCode, -1);
                this.streetCode = this.disabled(this.streetCode, -1);
                this.shequCode = this.disabled(this.shequCode, -1);
                if (!isArray) {
                    this.getOpenCityList(3, code);
                };
            };

            //选择区县
            if (level == 3) {
                this.streetList = [];
                this.shequList = [];
                this.streetCode = this.disabled(this.streetCode, -1);
                this.shequCode = this.disabled(this.shequCode, -1);
                if (!isArray) {
                    this.getOpenCityList(4, code);
                };
            };

            //选择街道
            if (level == 4) {
                this.shequList = [];
                this.shequCode = this.disabled(this.shequCode, -1);
                if (!isArray) {
                    this.getOpenCityList(5, code);
                };
            };

            //选择社区
            if (level == 5) {

            };
        },
        //如果不等于-1，则清空地址
        clearFrom() {
            this.title = "选择地址";
            this.show = false;
            this.isDisabled = [];
            this.provinceList = [];
            this.cityList = [];
            this.districtList = [];
            this.streetList = [];
            this.shequList = [];
            this.provinceCode = -1;
            this.cityCode = -1;
            this.districtCode = -1;
            this.streetCode = -1;
            this.shequCode = -1;
        },

        //如果不等于-1，则清空地址
        disabled(str, newStr) {
            if (str == newStr) {
                return newStr;
            } else {
                return "";
            }
        },

        //格式化code，一个code直接返回code，无code返回空，多个逗号隔开的code返回数组
        codeFmt(code) {
            if (this.$isblank(code)) {
                return "";
            }
            if (typeof code === "string") {
                var codeCache = code.split(",");
                // 去除空字符串，防止因连续逗号导致的空元素
                codeCache = codeCache.filter(item => item.trim() !== "");
                if (codeCache.length === 1) {
                    return codeCache[0];
                } else {
                    return codeCache;
                }
            } else {
                return code;
            };
        },
    }
}
</script>
<style>